/**
 * Indicate that we launched a request to save an online order.
 */
export const SAVE_ONLINE_ORDER_REQUEST = "SAVE_ONLINE_ORDER_REQUEST";
/**
 * Indicate that we successfully saved an online order.
 */
export const SAVE_ONLINE_ORDER_SUCCESS = "SAVE_ONLINE_ORDER_SUCCESS";
/**
 * Indicate that we failed to save an online order.
 */
export const SAVE_ONLINE_ORDER_FAILURE = "SAVE_ONLINE_ORDER_FAILURE";
/**
 * Indicate that we launched a request to calculate online order costs.
 */
export const CALCULATE_ONLINE_ORDER_COSTS_REQUEST = "CALCULATE_ONLINE_ORDER_COSTS_REQUEST";
/**
 * Indicate that we successfully calculate online order costs.
 */
export const CALCULATE_ONLINE_ORDER_COSTS_SUCCESS = "CALCULATE_ONLINE_ORDER_COSTS_SUCCESS";
/**
 * Indicate that we failed to calculate online order costs.
 */
export const CALCULATE_ONLINE_ORDER_COSTS_FAILURE = "CALCULATE_ONLINE_ORDER_COSTS_FAILURE";
/**
 * Indicate that we launched a request to save an online order.
 */
export const GET_ONLINE_ORDER_RESULTS_REQUEST = "GET_ONLINE_ORDER_RESULTS_REQUEST";
/**
 * Indicate that we successfully saved an online order.
 */
export const GET_ONLINE_ORDER_RESULTS_SUCCESS = "GET_ONLINE_ORDER_RESULTS_SUCCESS";
/**
 * Indicate that we failed to save an online order.
 */
export const GET_ONLINE_ORDER_RESULTS_FAILURE = "GET_ONLINE_ORDER_RESULTS_FAILURE";
/**
 * Indicate that we want to save a mail in the online order results.
 */
export const SAVE_MAIL_IN_ONLINE_ORDER_RESULTS = "SAVE_MAIL_IN_ONLINE_ORDER_RESULTS";

/**
 * Indicate that we launched a request to save a commande en ligne (nouveau parcours).
 */
export const SAVE_COMMANDE_EN_LIGNE_REQUEST = "SAVE_COMMANDE_EN_LIGNE_REQUEST";
/**
 * Indicate that we successfully saved a commande en ligne (nouveau parcours).
 */
export const SAVE_COMMANDE_EN_LIGNE_SUCCESS = "SAVE_COMMANDE_EN_LIGNE_SUCCESS";
/**
 * Indicate that we failed to save a commande en ligne (nouveau parcours).
 */
export const SAVE_COMMANDE_EN_LIGNE_FAILURE = "SAVE_COMMANDE_EN_LIGNE_FAILURE";

/**
 * Indicate that we launched a request to modify a commande en ligne (nouveau parcours).
 */
export const MODIFY_COMMANDE_EN_LIGNE_REQUEST = "MODIFY_COMMANDE_EN_LIGNE_REQUEST";
/**
 * Indicate that we successfully modified a commande en ligne (nouveau parcours).
 */
export const MODIFY_COMMANDE_EN_LIGNE_SUCCESS = "MODIFY_COMMANDE_EN_LIGNE_SUCCESS";
/**
 * Indicate that we failed to modify a commande en ligne (nouveau parcours).
 */
export const MODIFY_COMMANDE_EN_LIGNE_FAILURE = "MODIFY_COMMANDE_EN_LIGNE_FAILURE";

/**
 * Indicate that we launched a request to save the delivery step of a commande en ligne (nouveau parcours).
 */
export const SAVE_LIVRAISON_COMMANDE_EN_LIGNE_REQUEST = "SAVE_LIVRAISON_COMMANDE_EN_LIGNE_REQUEST";
/**
 * Indicate that we successfully saved the delivery step of a commande en ligne (nouveau parcours).
 */
export const SAVE_LIVRAISON_COMMANDE_EN_LIGNE_SUCCESS = "SAVE_LIVRAISON_COMMANDE_EN_LIGNE_SUCCESS";
/**
 * Indicate that we failed to save the delivery step of a commande en ligne (nouveau parcours).
 */
export const SAVE_LIVRAISON_COMMANDE_EN_LIGNE_FAILURE = "SAVE_LIVRAISON_COMMANDE_EN_LIGNE_FAILURE";

/**
 * Indicate that we launched a request to finalize a commande en ligne (nouveau parcours).
 */
export const FINALISER_COMMANDE_EN_LIGNE_REQUEST = "FINALISER_COMMANDE_EN_LIGNE_REQUEST";
/**
 * Indicate that we successfully finalized a commande en ligne (nouveau parcours).
 */
export const FINALISER_COMMANDE_EN_LIGNE_SUCCESS = "FINALISER_COMMANDE_EN_LIGNE_SUCCESS";
/**
 * Indicate that we failed to finalize a commande en ligne (nouveau parcours).
 */
export const FINALISER_COMMANDE_EN_LIGNE_FAILURE = "FINALISER_COMMANDE_EN_LIGNE_FAILURE";

/**
 * Indicate that we launched a request to get the online order in progress.
 */
export const GET_ONLINE_ORDER_IN_PROGRESS_REQUEST = "GET_ONLINE_ORDER_IN_PROGRESS_REQUEST";
/**
 * Indicate that we successfully got the online order in progress.
 */
export const GET_ONLINE_ORDER_IN_PROGRESS_SUCCESS = "GET_ONLINE_ORDER_IN_PROGRESS_SUCCESS";
/**
 * Indicate that we failed to get the online order in progress.
 */
export const GET_ONLINE_ORDER_IN_PROGRESS_FAILURE = "GET_ONLINE_ORDER_IN_PROGRESS_FAILURE";

/**
 * Indicate that we start a get duplication information request
 */
export const GET_DUPLICATION_INFORMATION_REQUEST = "GET_DUPLICATION_INFORMATION_REQUEST";

/**
 * Indicate that we successfully get information duplication
 */
export const GET_DUPLICATION_INFORMATION_SUCCESS = "GET_DUPLICATION_INFORMATION_SUCCESS";

/**
 * Indicate that we fail to get information duplication
 */
export const GET_DUPLICATION_INFORMATION_FAILURE = "GET_DUPLICATION_INFORMATION_FAILURE";
